export const tr = {
    'not-found': 'Sonuç bulunamadı',
    'not-selected': 'Hiçbir değer seçilmedi',
    'search-placeholder': 'Denemeyi veya segmenti bul',
    title: 'Teklif düzenlemeleri'
};
